import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_29_journal_voucher: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Journal Voucher",
    style: {},
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "journal_voucher",
        TableName: "vouchers",
        DisplayName: "vouchers",
        columnNumber: "m1 t1 w1",
        style: {
          padding: 10,
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
        },
        Fields: [
          {
            componentType: LayoutTypes.FIELD_GROUP,
            Label: "Journal voucher details",
            BindValue: "con_journal_voucher_details",
            style: {
              direction: FlexDirection.COLUMN,
            },
            childComponents: [
              {
                IncludeLabel: true,
                Label: "Voucher No.",
                PlaceHolder: "Will be auto generated...",
                IsMandatory: false,
                BindValue: "txt_voucher_no",
                Json_Attribute: "voucher_no",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                AutoPopulate: true,
                IsReadOnly: true,
                AutoPopulate_format: "JV_[******]",
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Jobcard No.",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "job_card_id",
                Json_Attribute: "job_card_id",
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                LookupName: "voucher_jobcard",
                IsVerticalView: true,
                showInSummary: true,
                validation: [],
              },
              {
                IncludeLabel: true,
                Label: "Voucher date",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "txt_voucher_date",
                Json_Attribute: "voucher_date",
                componentType: ComponentType.DATE_FIELD,
                showInSummary: true,
                IsVerticalView: true,
                DefaultToday: true,
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Voucher date is required",
                  },
                ],
              },
              {
                IncludeLabel: true,
                Label: "Narration",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_narration",
                Json_Attribute: "narration",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Ref No.",
                PlaceHolder: "Ref No.",
                IsMandatory: false,
                BindValue: "txt_Ref_no",
                Json_Attribute: "ref_no",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Voucher type",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_voucher_type_",
                Json_Attribute: "voucher_type",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                Default_Value: "Journal",
                IsReadOnly: true,
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Reference date",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "txt_reference_date",
                Json_Attribute: "ref_date",
                componentType: ComponentType.DATE_FIELD,
                showInSummary: true,
                IsVerticalView: true,
                DefaultToday: true,
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Reference date is required",
                  },
                ],
              },
            ],
          },
          {
            componentType: ComponentType.SUB_MODULE,
            name: "voucher_details",
            label: "Voucher details",
            tableName: "voucher_details",
            lookupName: "purchase_order_details",
            parentField: "txt_voucher_no",
            BindValue: "voucher_details",
            NotAllowEmpty: true,
            childControls: [
              {
                IncludeLabel: true,
                Label: "Ledger",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "drp_ledger",
                Json_Attribute: "ledger_id",
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                LookupName: "journal_ledgers",
                IsVerticalView: true,
                showInSummary: false,
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Ledger is required",
                  },
                ],
              },

              {
                IncludeLabel: true,
                Label: "Debit",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_credit",
                Json_Attribute: "credit",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: false,
                Default_Value: "0",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
              },
              {
                IncludeLabel: true,
                Label: "Credit",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_debit",
                Json_Attribute: "debit",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: false,
                Default_Value: "0",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
              },
              {
                IncludeLabel: true,
                Label: "Description",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "txt_remarks",
                Json_Attribute: "remarks",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                IsVerticalView: false,
                inputType: InputType.TEXT,
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Description is required",
                  },
                ],
              },
              {
                IncludeLabel: true,
                Label: "Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_amount",
                Json_Attribute: "",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[txt_debit]+[txt_credit]",
                Default_Value: "0",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
              },
            ],
            FooterControls: [
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_1",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                IncludeLabel: false,
                Label: "Total debit",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_total_debit",
                Json_Attribute: "total_debit",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_debit]",
                Default_Value: "0",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
              },
              {
                IncludeLabel: false,
                Label: "Total credit",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_total_credit",
                Json_Attribute: "total_credit",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_credit]",
                Default_Value: "0",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                validation: [
                  {
                    rule: ValidationRule.CONDITION,
                    condition: "[total_debit] == [total_credit]",
                    message: "Total debit and Total credit must be the same",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        componentType: ComponentType.BUTTON,
        name: "Submit",
        onPressAction: "save",
        style: {
          backgroundColor: "#22c55e",
          textColor: "#FFFFFF",
          padding: 12,
          borderRadius: 8,
        },
      },
    ],
  },
];

